import { hyphenateSync } from 'hyphen/cs';

// TODO: remove
/*
*   hyphenate function does not work with tag attributes, therefore
*   we have to itereate over textnodes
*/
export const hyphenateParagraph = paragraph => {
	iterateOverTextNodesNested(paragraph).forEach( textNode => {
		textNode.nodeValue = hyphenateSync(textNode.nodeValue);
	});
};

// TODO: remove
const iterateOverTextNodesNested = html => {
	const textNodes = [];
	const children = html.childNodes;

	children.forEach( node => {
		if (node.nodeType === 3) {
			textNodes.push(node);
		} else {
			textNodes.push(...iterateOverTextNodesNested(node));
		}

	});

	return textNodes;
};

export const lazyLoadComponent = async (componentNamespace, componentName) => {
	try {
		const { default: component } = await import(
			/* webpackChunkName: "component-lazy" */
			/* webpackMode: "lazy-once" */
			`./components/${componentNamespace}/${componentName}`
		);
		return component;
	} catch (error) {
		console.error(error);
	}
};

export const dispatchCustomEvent = (eventName, target, bubbles = true, options = {}) => {
	const event = new CustomEvent(eventName, {
		bubbles: bubbles,
		detail: {
			...options
		}
	});

	target.dispatchEvent(event);
};
